/**
 * Loads footer HTML files on-demand without needing the API.
 * Each language's footer is loaded as a separate chunk.
 */

const SUPPORTED_LANGUAGES = [
  'cs',
  'da',
  'de',
  'el',
  'es',
  'fi',
  'fr',
  'hr',
  'hu',
  'it',
  'ja',
  'ko',
  'ms',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sv',
  'th',
  'zh',
  'en',
];

/**
 * Dynamically loads footer HTML for a given language code.
 *
 * @param {string} languageCode - The language code (e.g., 'en', 'de', 'fr')
 * @returns {Promise<{data: string}>} Promise resolving to object with data property containing HTML string
 */
const loadFooterHTML = (languageCode) => {
  // Validate language code, defaulting to English if unsupported
  const code = SUPPORTED_LANGUAGES.includes(languageCode) ? languageCode : 'en'

  // Use dynamic imports with inline raw-loader to load HTML as strings.
  return import(
    /* webpackChunkName: "[request]" */
    `!raw-loader!../../../l10n/footers/footer-${code}.html`
  ).then((module) => ({ data: module.default }))
};

export { loadFooterHTML }
